import React from 'react'
import PropTypes from 'prop-types'
import { Chip as MuiChip, styled } from '@mui/material'
import NumberedLabel from './NumberedLabel'

const getBackgroundColor = (props) =>
    props.tone === 'dark' ? 'rgba(205, 205, 205, 1)' : 'rgba(223, 223, 223, 1)'

const getHoverBackgroundColor = (props) =>
    props.tone === 'dark' ? 'rgba(223, 223, 223, 1)' : 'rgba(205, 205, 205, 1)'

const StyledChip = styled(MuiChip)(({ theme, tone }) => ({
    backgroundColor: getBackgroundColor({ tone }),
    '&:hover': {
        backgroundColor: getHoverBackgroundColor({ tone }),
    },
}))

const Chip = (props) => (
    <StyledChip
        {...props}
        label={
            props.number ? (
                <NumberedLabel label={props.label} number={props.number} />
            ) : (
                props.label
            )
        }
    />
)

Chip.propTypes = {
    ...MuiChip.propTypes,
    tone: PropTypes.oneOf(['light', 'dark']).isRequired,
    number: PropTypes.number,
}

Chip.defaultProps = {
    ...MuiChip.defaultProps,
    tone: 'light',
}

export default Chip
